<template>
    <div class="flex flex-col items-center">
        <transition mode="out-in">
            <QuestionInputs
                v-if="!interruptionShow"
                :title="$root.data.questionTextAge"
                :values="$root.config.quiz.age"
                :flex-config="{desktop: {maxWidth: '32.625rem'}}"
                @value-changed="(value) => handleNext(value)"
            />
            <Interruption
                v-else-if="interruptionContent && interruptionShow"
                :config="{content: interruptionContent, isLastQuestion: true}"
                @goToNext="goToNext"
            />
        </transition>
    </div>
</template>

<script>
    import QuestionInputs from '@/apps/quiz/components/QuestionInputs.vue';
    import Interruption from '@/apps/quiz/components/Interruption.vue';

    export default {
        components: {
            QuestionInputs,
            Interruption
        },
        data() {
            return {
                interruptionShow: false,
                interruptionInstance: null,
                interruptionContent: null,
                value: null
            };
        },
        methods: {
            handleNext (value) {
                this.value = value;
                this.interruptionInstance = this.$root.config.quiz.age.find(answer => answer.id === this.value).interruption;

                if (this.interruptionInstance !== 'undefined' || this.interruptionInstance !== null) {
                    this.interruptionContent = this.interruptionInstance;
                }

                setTimeout(() => {
                    if (this.interruptionContent) {
                        this.interruptionShow = true;
                        window.innerWidth < 1024 ? window.scrollTo(0, 0) : document.querySelector('.js-route-content-container').scrollTo(0, 0);
                    } else {
                        this.goToNext();                        
                    }
                }, 300);
            },
            goToNext () {
                if (this.$root.config.emailOptIn.shouldRender) {
                    this.$router.push({
                        name: 'EmailOptIn',
                        params: {
                            age: this.value
                        }
                    });
                } else {
                    this.$router.push({
                        name: 'Results',
                        params: {
                            age: this.value,
                            emailOptIn: this.$root.config.emailOptIn.customer.acceptsMarketing
                        }
                    });
                }
            }
        }
    };
</script>

<style scoped>
    .v-enter-active,
    .v-leave-active {
        transition: all 0.3s ease-out;
    }

    .v-enter-from,
    .v-leave-to {
        @apply opacity-0;
    }
</style>
